<template>
  <div>
    <div class="">
      <p class="display-1 mt-7">결제 관리</p>

      <p class="mb-0 subtitle-1 font-weight-light">
        포인트 판매 서비스 사용을 위한 결제 및 내역을 확인하실 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        호스팅서버/API 연동등 관련 비용을 월 2.9만원 (VAT별도) 결제하여 사용하실
        수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쇼핑몰 회원들에게 포인트 혜택을 제공하여 매출과 고객만족을 높여보세요.
      </p>
      <Payment></Payment>
      <PaymentList></PaymentList>
    </div>
  </div>
</template>

<script>
import Payment from "@/components/mileage/payment/component/Payment.vue";
import PaymentList from "@/components/mileage/payment/component/PaymentList.vue";

export default {
  components: {
    Payment,
    PaymentList,
  },
};
</script>
